import {gql} from 'apollo-angular';


export const constituentImagesGql = gql`
query ReloadImagesGql($individualConstituentId: [Int!]) {
    IndividualConstituent(individualConstituentId: $individualConstituentId) {
        constituentImageLibraries {
            imagePath
            imageName
            constituentImageLibraryId
        }
    }
}
`;